import { useEffect, useState } from 'react';

import { useStoreDetails } from 'context/store-context';
import { Position } from 'types';

import useScreenSize from './useScreenSize';

const useWidgetPosition = () => {
  const [isLeftPosition, setLeftPosition] = useState<boolean>(false);
  const {
    widgetOption: { widgetPosition, position }
  } = useStoreDetails();
  const { isMobile } = useScreenSize();

  useEffect(() => {
    if (isMobile) {
      setLeftPosition((widgetPosition?.mobile || position) === Position.LEFT);
    } else {
      setLeftPosition((widgetPosition?.desktop || position) === Position.LEFT);
    }
  }, [isMobile]);
  return isLeftPosition;
};

export default useWidgetPosition;
